import React from 'react';
import classnames from 'classnames';

import { FormPageFieldHeader, FormPageFieldInfo } from 'types/formPage';


import cls from './form-header.module.scss';
import {renderValue} from "../utils";

/* eslint-disable */

export type FormHeaderProps = {
  className?: string;
  header?: FormPageFieldHeader;
  subHeader?: FormPageFieldInfo;
  headerPlaceholder?: string;
  subHeaderPlaceholder?: string;
  headerProps?: any;
  subHeaderProps?: any;
};

export const FormHeader = ({ className = '', header = {} as FormPageFieldHeader, subHeader }: FormHeaderProps) => {

  const {content = {} as FormPageFieldHeader} = header
  console.log("Rendering Header", header, content)
  return (
    <div className={classnames(className)}>
      {header && (
        <>
          {header.logo_url && <img className={cls.headerLogo} src={header.logo_url} />}
          {renderValue(content.content, {render_as: content.render_as || 'markdown',...header})}
        </>
      )}
    </div>
  );
};

export default FormHeader;
